import { media, styled } from '@styles';
import { css } from 'styled-components';
import { Container } from '@components/templates/Container';
import { paddingLeft, pageTitle, prismicRichText } from '@styles/utils';

import chevronLeftImage from 'images/chevron_left.svg';
import chevronRightImage from 'images/chevron_right.svg';

const slickArrow = css`
  .slick-arrow {
    left: auto;
    top: 50%;
    border-radius: 50%;
    width: 56px;
    height: 56px;
    color: transparent;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    box-shadow: 0px 4px 34px rgba(0, 0, 0, 0.08);
    z-index: 1;
    transform: translate3d(0, 0, 0);
    ${media.largeScreen`
      background-size: cover !important;
      width: 42px;
      height: 42px;
    `}
    ${media.mediumScreen`
      transform: translate(0, -50%);
    `}
    ${media.smallScreen`
      width: 33px;
      height: 33px;
      transform: translate3d(0, 0, 0);
    `}
    &:before {
      content: none;
    }
  }
`;

const slickPrev = css`
  .slick-prev {
    background: url(${chevronLeftImage}) no-repeat center !important;
    left: 15px;
    &:hover,
    &:focus,
    &:active {
      background: url(${chevronLeftImage}) no-repeat center !important;
    }
    &.slick-disabled {
      opacity: 0.5;
    }
  }
`;

const slickNext = css`
  .slick-next {
    background: url(${chevronRightImage}) no-repeat center !important;
    right: 15px;
    &:hover,
    &:focus,
    &:active {
      background: url(${chevronRightImage}) no-repeat center !important;
    }
    &.slick-disabled {
      opacity: 0.5;
    }
  }
`;

const slickSlider = css`
  .slick-slider {
    margin: 0 -16px;
  }
`;

const slickSlide = css`
  .slick-slide {
    padding: 0 15px;
  }
`;

export const Wrapper = styled.div`
  ${slickArrow}
  ${slickPrev}
  ${slickNext}
  ${slickSlider}
  ${slickSlide}
`;

export const Padding = styled(Container)`
  ${paddingLeft}
`;

export const Title = styled.div`
  margin-bottom: 90px;
  ${media.largeScreen`
    margin-bottom: 40px;
  `}
  ${media.smallScreen`
    text-align: center;
    margin-bottom: 30px;
  `}
  ${pageTitle}
`;

export const ContentWrapper = styled.div`
  .list-content-container {
    display: flex;
    ${media.smallScreen`
      display: block;
    `}
  }

  .list-content-col {
    &.col-full-width {
      width: 100%;
    }
    &:not(:last-child) {
      margin-right: 40px;
    }
  }

  .list-content-col--left {
    width: 66.6%;
    ${media.smallScreen`
      width: 100%;
    `}
  }

  .list-content-col--right {
    width: 33.4%;
    ${media.smallScreen`
      width: 100%;
    `}
  }

  .block-embed {
    height: 100vh;
    ${media.smallScreen`
      height: 60vh;
    `}
  }

  * {
    line-height: inherit;
  }
  ${prismicRichText}
`;
